export default {
  coming_soon: "곧 온다...",
  virtual_games: "가상",
  support: "문의정보",
  bet_limit: "베팅 한도",
  favorites: "즐겨찾기",
  note: "주의사항",
  my_bets: "내 베팅",
  my_account: "내 계정",
  contact_us: "문의정보",
  report: "리포트",
  help_support: "도움말 및 지원",
  currency: "통화",
  others: "다른",
  welcome: "어서 오십시오",
  account_id: "계정 ID",
  password: "암호",
  account: "계정",
  all_sports: "모든 스포츠",
  my_sports: "스포츠",
  action: "동작",
  accept_better_odds: "더 나은 배당률 수락",
  accept_any_odds: "모든 배당률 승인",
  auto_refresh_odds: "배당률 자동 새로고침",
  auto_refresh: "자동 새로고침",
  auto_refreshing: "자동 새로고침...",
  all_markets: "모든 시장",

  away: "원정팀",

  all: "모두",
  accepted: "받아 들여",
  add_to_parlay: "팔레이에 추가",
  add_to_booster: "Add To Booster",
  amount: "양",
  amount_before_balance: "잔액 전 금액",
  amount_after_balance: "잔액 후 금액",

  bet_slip: "베팅 슬립",
  bet_credit: "베팅금액",
  bet_list: "배팅목록",
  betting: "베팅",
  balance: "잔액",

  betting_statement: "배팅 결과",
  bet_types: "베팅의 종류",
  bet_type: "베팅의 종류",
  bs: "B/S",
  bet_summary: "베팅 서머리",
  bet_reject: "무효 베팅 ",
  bets: "베팅",
  bet: "베팅",
  booster: "Boost",

  casino: "카지노",
  mini_casino: "미니 카지노",
  cash_balance: "보유금액",
  change_account_password: "계정 암호 변경",
  current_password: "현재 비밀 번호를 확인하시기 바랍니다",
  confirm_new_password: "비밀 번호 확인",
  customize_sports_order: "스포츠 오더 사용자 정의",
  choice: "선택",
  credit: "획득",
  commission: "수수료",
  customize: "커스터마이즈",
  cancel: "취소",
  confirmation: "확인",
  closing_balance: "폐쇄 잔액",
  clear_filter: "필터 지우기",

  debit: "손실",
  display_language: "표시 언어",
  default_event_sorting: "기본 이벤트 정렬",
  default_stake: "기본 베팅금액",
  date: "데이트",
  draw: "무승부",
  draw_cancel: "무승부",
  dec: "소수점 배당률",
  double_line: "더블 라인",
  disable: "비활성화",
  dec_odds: "소수점 배당률",
  id_odds: "인도네시아 확률",
  double_chance: "더블 찬스",

  enable: "가능하게하다",
  event_sorting: "이벤트 정렬",
  esports: "E 스포츠",
  esports2: "E 스포츠",
  e_sports: "E 스포츠",
  edit: "편집",
  early: "초기",
  event: "경기",
  even: "짝",

  first_goal: "첫 득점",
  first_half: "전반전 득점",
  final: "최종 점수",
  full_time: "전후반경기",
  first_5_inn: "First 5 Innings",

  games: "게임",
  given_credit: "기븐크레딧",
  group: "그룹",
  goal: "골",

  half_time: "전반",
  hide_header: "헤더 숨기기",
  hk: "HK",
  hk_odds: "HK | 홍콩 배당률",
  home: "홈",

  id: "ID",
  inactive: "비활성",
  inplay: "In-Play",

  keno: "키노",
  kickoff: "시합개시",

  lottery: "로또",
  login: "가입",
  logout: "로그아웃",
  last_login: "마지막 로그인",
  last_transaction: "마지막 거래",
  live_streaming: "생방송",
  live_tv: "생방송",
  live_match: "라이브 매치",
  live: "라이브",
  live_center: "라이브 센터",
  livecasino: "라이브 카지노",
  loss: "손실",
  lost: "잃다",
  lose: "잃다",
  lose_half: "반을 잃다",
  last_bet: "마지막 베팅",
  last_goal: "마지막골",

  mobile: "핸드폰",
  message: "메시지",
  my_bet: "내 베팅",
  my_favorites: "즐겨찾기",
  market_type: "마켓 유형",
  match: "경기",
  message_history: "메시지 히스토리",
  my: "MY",
  market: "시장",
  main_markets: "주요 시장",
  my_odds: "말레이 배당률",
  min: "최저한의",
  max: "최고",
  max_payout: "최대 배당금 ",
  main: "주요",
  corners: "코너킥/경고,퇴장",
  specials: "스페셜",
  mix_parlay: "믹스 팔레이",
  moneyline: "머니 라인",

  no_goal: "노 골",
  normal_announcements: "일반 공지 사항",
  nickname: "닉네임",
  new_password: "새 비밀번호",
  new: "뉴",
  "no/": "숫자.",
  normal_sorting: "일반 분류",

  other_markets: "기타 마켓",
  outstanding: "베팅중인 내역",
  odds_type: "배당률 종류",
  odds: "확률",
  opening_balance: "기초 잔액",
  outright: "승자 예상 배팅",
  on: "켜짐",
  off: "꺼짐",
  outstanding_bet: "뛰어난 내기",
  over: "오버",
  odd: "홀수",
  hdp: "핸디캡",
  ou: "오버/언더",
  oe: "홀수/짝수",
  oxt: "1X2",
  ml: "머니라인",

  password_expiry: "비밀번호 만료",
  parlay: "팔레이",
  page_display: "페이지 표시",
  page_type: "페이지 유형",
  page_size: "웹페이지 크기",
  personal_message: "개인 공지사항",
  process_bet: "베팅 하기",
  payout: "지불 금액",
  pending: "보류",

  quick_bet: "빠른 베팅",
  quick_bet_stake: "빠른 베팅 베팅액",

  result: "게임 결과 ",
  restore: "복원하기",
  remark: "결과",
  ref_no: "Ref No.",
  remove_from_parlay: "Remove Parlay",
  remove_from_booster: "Remove Booster",
  running: "경시 시작",
  rules: "규칙",
  rules_regulations: "규칙 및 규정",

  sports: "스포츠",
  show_balance: "밸런스 표시",
  statement: "거래내역서",
  settings: "설정",
  search_team: "팀 검색",
  show_header: "헤더 표시",
  submit: "제출하다",
  set_nickname: "닉네임 설정",
  single: "싱글",
  save: "저장",
  show_score_map: "스코어 맵 표시",
  stake: "판돈",
  status: "상태",
  sort: "활자 한 벌",
  sportsbook: "스포츠북",
  sum: "SUM",
  special_announcements: "특별 공지 사항",
  subtotal: "소계",
  single_line: "더블 라인",
  sort_by_time: "시간으로 분류",
  slots: "슬롯",
  mini_slots: "미니 슬롯",
  select_leagues: "리그선택",
  settled_amount: "정산 금액",

  turnover: "총배팅액",
  today: "오늘",
  time: "시간",
  team: "팀",
  to: "에",
  trans_time: "배팅 시간",
  total: "합계",
  total_goal: "총 득점",
  treble: "3배",
  transaction_date: "배팅 날짜",
  transfer_method: "전환 방법",
  transfer: "전송",

  under: "언더",
  void: "무효",
  reject: "받지 않다",
  rejected: "받지 않다",
  valid_turnover: "유효한 회전율",

  win: "승리",
  won: "승리",
  won_half: "절반승리",
  waiting: "기다리는",

  yes: "예",
  no: "아니",

  yesterday: "어제",
  monday: "월요일",
  tuesday: "화요일",
  wednesday: "수요일",
  thursday: "목요일",
  friday: "금요일",
  saturday: "토요일",
  sunday: "일요일",

  all_league: "모든",
  match_completed: "종료",
  match_pending: "결과 보류",
  match_cancelled: "환불",
  match_cancelled_1h: "환불 1H",
  match_cancelled_2h: "환불 2H",
  match_suspended: "Abandoned",
  match_suspended_1h: "Abandoned 1H",
  match_suspended_2h: "Abandoned 2H",

  check_all: "모두 체크하기",
  selected_only: "선택 항목만",
  filtered: "거르는",
  turn_on: "켜짐",
  turn_off: "꺼짐",

  preference: "내 환경 설정",

  market_1: "초기",
  market_2: "오늘",
  market_3: "In-Play",

  // 규칙 및 규정

  // asian_handicap: "아시아 핸디캡",
  // acceptance_countdown: "카운트다운 타이머 승인",
  // acceptance_rules: "일반 약관 및 베팅 규칙 동의",
  // application_betting_rule: "일반 베팅 규칙의 적용",
  // bettype_settlement_rule: "베팅 유형 결정 규칙",
  // change_schedule: "예정 시각의 변경",
  // change_venue: "장소 변경",
  // cons_interpret: "구성 및 해석",
  // definition_of_term: "용어 정의",
  // general_betting_rule: "일반 베팅 규칙",
  // general_terms: "일반 약관",
  // general_provision: "일반 조항",
  // general_rules_bt: "시장(베팅 유형) 규칙 일반 규칙",
  // handicaps: "Handicap (HDP), 1st Half Handicap후반전 핸디캡",
  // running_bet_service: "진행 중인 (“라이브”) 베팅 서비스",
  // limitation_provision: "책임 제한 및 보장 조항",
  // match_duration: "진행 시간",
  // member_account: "회원 계정",
  // mixparlays: "믹스 팔레이",
  // mixparlay_payout: "믹스 팔레이 최대 지불금",
  // over_unders: "Over/Under (OU), 1st Half Over/Under &후반전 오버/언더",
  // odd_evens: "Odd/Even (OE), 1st Half Odd/Even &후반전 홀/짝",
  // rules_governing: "규칙: 일반 및 특정 이벤트",
  // results: "결과보기",
  // software_game: "소프트웨어 및 게임",
  // single_team_oe: "싱글 팀 홀/짝",
  // sport_betting_rule: "스포츠 베팅 규칙",
  // terms_of_transact: "거래 약관",
  // warranties: "회원의 보증 및 진술",

  american_football: "미식 축구",
  soccer: "축구",
  basketball: "농구",
  baseball: "야구",
  esports: "E 스포츠",
  tennis: "테니스",

  events: "경기",
  brackets: "브라켓",
  standing: "서 있는",

  euro2020: "UEFA 유로 2020",

  play_now: "지금 플레이",

  processing: "가공...",

  big_small: "큰/작은",
  odd_even: "홀수/짝수 | 홀수/짝수",

  first_digit: "1 자리",
  second_digit: "2 자리",
  third_digit: "3 자리",
  forth_digit: "4 자리",
  total_4d: "Total 4D",
  total_3d: "Total Last 3D",
  total_1st2d: "Total 1st 2D",
  total_last2d: "Total Last 2D",

  official_link: "외부 링크",

  virtual_sports: "가상 스포츠",
  virtual_soccer: "가상 축구",
  virtual_horse_racing: "온라인 경마",
  virtual_dog_racing: "온라인 그레이하운드 경주",
  virtual_motorsport: "온라인 자동차경주",

  prize1: "1ST PRIZE",
  prize2: "2ND PRIZE",
  prize3: "3RD PRIZE",

  round1: "ROUND 1",
  round2: "ROUND 2",
  round3: "ROUND 3",
  round4: "ROUND 4",
  round5: "ROUND 5",

  map1: "MAP 1",
  map2: "MAP 2",
  map3: "MAP 3",
  map4: "MAP 4",
  map5: "MAP 5",
  map6: "MAP 6",
  map7: "MAP 7",
  map8: "MAP 8",
  map9: "MAP 9",
  map10: "MAP 10",

  mini_games: "미니 게임",

  sysparlay: "개의 팔레이",
  abets: "내기",
  afold: "폴드",
  fold: "폴드",

  continue: "계속하다",
  highlight: "가장 밝은 부분",
  show_all_time: "항상 보여",
  back: "뒤",
  fishing: "낚시 게임",
  upnext: "다음",
  no_video: "비디오 없음",
  mm_odds: "미얀마 확률",
  mmo_parlay: "팔레이 미얀마",
  myanmar: "미얀마",
  combo: "콤보",
  total_bet: "모든 베팅 ",
  total_stake: "모든 금액이 걸렸습니다.",
  total_match: "게임 수",
  combination: "콤비네이션",
  stakeperbet: "단일 베팅",
  total_payout: "모든 지불",
  total_accept: "합계 수락",
  total_reject: "최대 거부",
  sum_wl: "총 승패",
  sum_bet: "총 승패",

  days: "일",
  hours: "시간",
  mins: "의사록",
  secs: "초",

  abandoned: "버려진",
  score: "점수",
  winner: "우승자",

  upcoming: "다가오는",

  adjustment: "조정",
  poker: "포커"
};
